<template>
  <div>
    <v-card :class="`d-flex justify-center`" flat tile>
      <v-card
        v-for="interval in intervals"
        :key="interval.from"
        class="pa-2"
        outlined
        :style="`background: rgba(51, 136, 255, ${interval.opacity});`"
        tile
      >
        <div>[{{ interval.from }}, {{ interval.to }}]</div>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";
import { NOWCASTING_INTERVALS } from "../../../constants";

export default {
  name: "IntervalScale",
  props: {
    /**
     * validtimes
     */
    items: {
      type: Array,
      default: function() {
        return [];
      }
    },
    /**
     * selected validtime
     */
    value: Number
  },
  data: function() {
    return {
      intervals: NOWCASTING_INTERVALS
    };
  },
  methods: {
    getWeatherImage(interval) {
      if (interval[1] === 0) {
        return this.clearImage;
      }

      if (interval[1] > 0 && interval[1] <= 10) {
        return this.cloudsImage;
      }

      if (interval[1] > 10 && interval[1] <= 40) {
        return this.rainImage;
      }

      if (interval[1] > 40) {
        return this.thunderstormImage;
      }
    },
    changeSlide(value) {
      this.$emit("input", value);
    },
    hourAndMinutes(value) {
      return moment(value).format("HH:mm");
    }
  }
};
</script>